let pageSections = $('.site-main').children(),
    scrollButton = $('.scroll-btn');

$.each(pageSections, function () {
    let newID = 'section-' + parseInt($(this).index() + 1);
    let newHref = '#section-' + parseInt($(this).index() + 2);
    $(this).attr('id', newID)
    $(this).find(scrollButton).attr('href', newHref);
});

$(document).on('click', '.scroll-btn', function (e) {
    e.preventDefault();
    if (this.hash !== "") {
        var hash = this.hash;
        $('html, body').animate(
            { scrollTop: $(hash).offset().top - 78 }, 800);
    }
})



// WEBPACK FOOTER //
// ./scripts/modules/scroll-to-section.js